import { Flex, Text } from '@chakra-ui/react';
import { UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputField } from '@/components/InputField';

const PREFIX = 'pages.application_roster_member.components.roster_member_stats_fields';

type StatKey =
  | 'matches'
  | 'wins'
  | 'draw'
  | 'lose'
  | 'goals'
  | 'assists'
  | 'total_shots'
  | 'shots_on_target'
  | 'yellow_cards'
  | 'red_cards'
  | 'goals_conceded';

const STAT_ROWS: StatKey[][] = [
  ['matches', 'wins'],
  ['draw', 'lose'],
  ['goals', 'assists'],
  ['total_shots', 'shots_on_target'],
  ['yellow_cards', 'red_cards'],
  ['goals_conceded'],
];

export interface RosterMemberStatsFieldsProps {
  register: UseFormRegister<any>;
  errors?: any;
}

export const RosterMemberStatsFields = ({ register, errors }: RosterMemberStatsFieldsProps) => {
  const { t } = useTranslation();

  return (
    <Flex direction='column' gap={2}>
      <Text fontWeight='bold' fontSize='sm' color='gray.600' textTransform='uppercase'>
        {t(`${PREFIX}.roster_member_stats_section`)}
      </Text>
      {STAT_ROWS.map(row => (
        <Flex key={row.join('_')} direction={{ base: 'column', md: 'row' }} gap={6}>
          {row.map(key => (
            <InputField
              key={key}
              withoutFloating
              type='number'
              label={t(`${PREFIX}.roster_member_stats_${key}`)}
              rootProps={{
                isInvalid: !!errors?.stats?.[key],
                errorMessage: errors?.stats?.[key]?.message,
              }}
              {...register(`stats.${key}`)}
            />
          ))}
        </Flex>
      ))}
    </Flex>
  );
};
